(function () {

    angular.module('FotocApp')

        .service('$editorService', ['CONSTANTS', '$rootScope', '$injector', '$window', function (CONSTANTS, $rootScope, $injector, $window) {

            var self = this;
            $rootScope.$editorService = this;
            this.Moneda = $window.Moneda;
            this.CONSTANTS = CONSTANTS;
            this.FOTOCEDITOR_EDITOR_ASSETS = FOTOCEDITOR_EDITOR_ASSETS;
            this.uploadCare;
            this.openModalUploadCarteFunct = null; // lo setea images.component
            this.siteConfig = {};

            this.ui = {
                type: $window.TYPE_EDITOR,
                showTools: true,
                initialType: $window.TYPE_EDITOR,
                uploadCareMultiFile: false,
                layoutMosaicTabX: null,
                layoutDefaultTabsWidth: false,
                loadDefaultGallery: false,
                drawFrame3d: true,
                config: {},
                toolOpen: 'images',
                imageSearchIsOpen: false,
                favs: $window.localStorage.getItem('editor.service.favs__' + $window.TYPE_EDITOR) ? JSON.parse($window.localStorage.getItem('editor.service.favs__' + $window.TYPE_EDITOR)) : [],
                images: [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}],
                filters: [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}],
                imagesTabActive: 'stock',
                my_galery: [],
                enabledSaveFavs: true,
                cacheFilters: {},
                cacheImages: {},
                lastFrameColorSelected: 'NONE',
                cacheLayouts: {
                    mosaic: {},
                    combined: {},
                    simple: {}
                },
                intervalSubmission: {},
                editingItem: 0,
                layouts: null,
                ambients: null,
                view: { type: 'edit', id: null },
                bgColor: '#444',
                showMeasures: false,
                lang: [],
                slidersDivs: {
                    rotation: null,
                    scale: null
                },
                sizeManualSelected: 'M',
                availablesSizes: ['XXXL', 'XXL', 'XL', 'L', 'M', 'S', 'XS', 'SSX'],
                frameColors: []
            };

            this.data = {
                type: $window.TYPE_EDITOR,
                group: '1',
                images: [],
                layout_id: null,
                layout_size: null,
                material: 'B',
                cost: {
                    currency: '',
                    price: { total: '' }
                }
            };

            this.hideTools = function () {
                var w = Math.max(document.documentElement.clientWidth, $window.innerWidth || 0);

                if (w <= 640) {
                    this.ui.toolOpen = false;
                }
            };

            // Trae precios y detalle de la promocion activa en este momento
            this.setObjectPrice = function () {

                if (this.data.layout_id && (typeof (EDITOR_ADMIN_MODE) === 'undefined' || EDITOR_ADMIN_MODE === false)) {
                    try {
                        if (this.ui.compositionsAsGroup) {
                            self.data.cost = $window.calcSimulatedCart(self.getLayout().price, this.data.images.length);
                        } else {
                            self.data.cost = $window.calcItemPrice(self.getLayout().price, 1, true);
                        }
                    } catch (e) {
                        console.warn(e);
                        self.data.cost = { price: { total: '-' } };
                    }
                }

            };

            this.getItemEditing = function ($forceItemNum) {

                if (typeof ($forceItemNum) === "undefined") {
                    $forceItemNum = this.ui.editingItem;
                }

                if (angular.isUndefined(this.data.images[$forceItemNum])) {
                    this.data.images[$forceItemNum] = {
                        type: null,
                        filter: null,
                        frameColor: null,
                        data: { id: -1 },
                        urlWithFilter: null,
                        urlWithoutFilter: null,
                        position: {
                            x: null,
                            y: null,
                            scaleX: null,
                            scaleY: null,
                            rotation: null
                        }
                    };
                }

                return this.data.images[$forceItemNum];
            };

            this.initConfig = function (editor) {

                this.siteConfig = window.editorConfig[editor];
                this.ui.layouts = this.getLayouts();
                this.ui.showTools = this.siteConfig.config.config.showTools;
                this.ui.ambients = this.siteConfig.config.ambients;
                this.ui.config = this.siteConfig.config.config;
                this.ui.bgColor = this.siteConfig.config.config.canvasBgColor;
                this.ui.toolOpen = this.siteConfig.config.config.initTool;
                this.ui.frameColors = this.siteConfig.config.frameColors;
                this.ui.uploadCareMultiFile = this.siteConfig.config.config.uploadCareMultiFile;
                this.ui.drawFrame3d = this.siteConfig.config.config.drawFrame3d;
                this.ui.layoutMosaicTabX = this.siteConfig.config.config.layoutMosaicTabX;
                this.ui.layoutDefaultTabsWidth = this.siteConfig.config.config.layoutDefaultTabsWidth;
                this.ui.layoutShowTabIndividuals = this.siteConfig.config.config.layoutShowTabIndividuals;
                this.ui.loadDefaultGallery = this.siteConfig.config.config.loadDefaultGallery;
                this.ui.compositionsAsGroup = this.siteConfig.config.config.compositionsAsGroup;
                this.data.group = this.ui.compositionsAsGroup ? 0 : 1;
                this.ui.layoutShowImageTitle = this.siteConfig.config.config.layoutShowImageTitle;
                this.ui.layoutShowProductDescription = this.siteConfig.config.config.layoutShowProductDescription;
                this.ui.showLayoutSelector = this.siteConfig.config.config.showLayoutSelector;
                this.ui.layoutShowAddToCartButton = this.siteConfig.config.config.layoutShowAddToCartButton;
                this.ui.layoutShowBtnToolFrame = this.siteConfig.config.config.layoutShowBtnToolFrame;
                this.ui.layoutShowBtnMeasures = this.siteConfig.config.config.layoutShowBtnMeasures;
                this.ui.ambientSizeGroupBorder = this.siteConfig.config.config.ambientSizeGroupBorder;
                this.ui.showBorderEditingitem = this.siteConfig.config.config.showBorderEditingitem;
                this.ui.needResetTransformable = this.siteConfig.config.config.needResetTransformable;
                this.ui.useShutterStockGallery = this.siteConfig.config.config.useShutterStockGallery;
                this.ui.returnAllSelectedImages = this.siteConfig.config.config.returnAllSelectedImages;
                this.ui.gradientFrameColors = this.siteConfig.config.config.gradientFrameColors;
                this.ui.launchTutorialOnInit = this.siteConfig.config.config.launchTutorialOnInit;
            };

            this.getFilterLayouts = function () {
                if ($window.DomainCode !== undefined &&
                    $window.DomainCode !== "" &&
                    this.siteConfig.config.filterAndConfig.site[$window.DomainCode] !== undefined
                ) {
                    return this.siteConfig.config.filterAndConfig.site[$window.DomainCode];
                }
                return this.siteConfig.config.filterAndConfig.defaultByType;
            };

            this.getLayouts = function () {
                var filter = this.getFilterLayouts();
                var layouts = this.siteConfig.data.layouts;

                if (filter && filter.layouts && filter.layouts.exclude_ids && filter.layouts.exclude_ids.length) {
                    filter.layouts.exclude_ids.forEach(function (k) {
                        if (layouts[k]) {
                            delete layouts[k.toString()];
                        }
                    });
                }

                if (filter && filter.layouts && filter.layouts.allowed_package && filter.layouts.allowed_package.length > 0) {
                    Object.keys(layouts).forEach(function (k, e) {
                        Object.keys(layouts[k.toString()].sizes).forEach(function (l, e) {
                            if (
                                layouts[k.toString()].sizes[l.toString()].package !== "undefined" &&
                                filter.layouts.allowed_package.indexOf(layouts[k.toString()].sizes[l.toString()].package) === -1
                            ) {
                                delete layouts[k.toString()].sizes[l.toString()];
                            }
                        });
                    });
                }

                //console.log("---------------- LAYOUTS ---------");
                //console.log(layouts);
                //console.log("----------------------------------");

                if (filter && filter.layouts && filter.layouts.max_size_group && filter.layouts.max_size_group.length === 2) {
                    Object.keys(layouts).forEach(function (k, e) {
                        Object.keys(layouts[k.toString()].sizes).forEach(function (l, e) {
                            if (
                                layouts[k.toString()].sizes[l.toString()].size_group[0] > filter.layouts.max_size_group[0] ||
                                layouts[k.toString()].sizes[l.toString()].size_group[1] > filter.layouts.max_size_group[1]
                            ) {
                                delete layouts[k.toString()].sizes[l.toString()];
                            }
                        });
                    });
                }

                if (filter && filter.layouts && filter.layouts.min_size_group && filter.layouts.min_size_group.length === 2) {
                    Object.keys(layouts).forEach(function (k, e) {
                        Object.keys(layouts[k.toString()].sizes).forEach(function (l, e) {
                            if (
                                layouts[k.toString()].sizes[l.toString()].size_group[0] < filter.layouts.min_size_group[0] ||
                                layouts[k.toString()].sizes[l.toString()].size_group[1] < filter.layouts.min_size_group[1]
                            ) {
                                delete layouts[k.toString()].sizes[l.toString()];
                            }
                        });
                    });
                }

                return layouts;
            };

            function isEmpty(obj) {
                for (var key in obj) {
                    if (obj.hasOwnProperty(key))
                        return false;
                }
                return true;
            }

            this.initLayout = function () {
                var queryString = window.location.search;
                var urlParams = new URLSearchParams(queryString);
                if (urlParams.has("eLayout") && typeof this.ui.layouts[urlParams.get("eLayout").toString()] !== "undefined") {
                    this.setLayout(urlParams.get("eLayout").toString(), urlParams.get("eLayoutSize"));
                } else {
                    this.setLayout(Object.keys(this.ui.layouts)[0]);
                }
            };

            this.setLayout = function ($id, $layout_size) {
                if (this.data.layout_id === $id && this.data.layout_size === $layout_size) {
                    return;
                }

                this.data.layout_id = $id;
                this.ui.editingItem = 0;

                if (this.data.group === 0) {
                    this.ui.cacheLayouts['mosaic'][$id] = true;
                } else {
                    this.ui.cacheLayouts['combined'][$id] = true;
                    this.ui.cacheLayouts['simple'][$id] = true;
                }

                if (typeof ($layout_size) === 'undefined') {
                    this.data.layout_size = searchSilimarSizeFromPreviousManualSelecter(this.ui.layouts[$id.toString()])
                } else {
                    this.data.layout_size = $layout_size;
                }

                if (typeof (this.ui.layouts[$id.toString()].frameColor) !== 'undefined') {
                    this.ui.lastFrameColorSelected = this.ui.layouts[$id.toString()].frameColor
                } else {
                    this.ui.lastFrameColorSelected = 'NONE';
                }

                var canvasService = $injector.get('$canvasService');
                canvasService.setLayout(false);

                this.setObjectPrice();

            };

            this.getLayout = function () {
                if (this.data.layout_id && !isEmpty(this.ui.layouts) && this.ui.layouts[this.data.layout_id.toString()]) {
                    return this.ui.layouts[this.data.layout_id.toString()].sizes[this.data.layout_size];
                }
            };

            this.getImageEditing = function () {
                return this.data.images[this.ui.editingItem];
            };

            this.addToImages = function ($item) {
                for (var i in this.ui.images) {
                    if (this.ui.images[i].id === $item.id) return;
                }
                this.ui.images.push($item)
            };

            this.setCacheFilter = function ($editingItem) {
                if (angular.isUndefined(this.ui.cacheFilters[this.data.images[$editingItem].urlWithoutFilter])) {
                    this.ui.cacheFilters[this.data.images[$editingItem].urlWithoutFilter] = {}
                }
                this.ui.cacheFilters[this.data.images[$editingItem].urlWithoutFilter][this.data.images[$editingItem].filter.id] = this.data.images[$editingItem].urlWithFilter;
            };

            this.setCacheImages = function ($url_key) {
                this.ui.cacheImages[$url_key] = true
            };

            this.showMessage = function ($msg) {
                alert($msg);
            };

            // for api
            this.extract_preview_url = function (url, width, height) {
                var preview_url_regex = /https:\/\/image\.shutterstock\.com\/display_pic_with_logo\/([0-9,]+)\/([0-9,]+)\/[A-Za-z]+-[A-Za-z]+-((.*?)([0-9]+\.jpg))/g;
                var m = preview_url_regex.exec(url);

                if (m !== null && m.length >= 6) {
                    var resizedHeight;
                    var resizedWidth;
                    if (parseInt(width, 0) >= parseInt(height, 0)) {
                        resizedHeight = 260;
                        resizedWidth = parseInt(260 * (parseInt(width, 0) / parseInt(height, 0)), 0);
                    } else {
                        resizedWidth = 260;
                        resizedHeight = parseInt(260 * (parseInt(height, 0) / parseInt(width, 0)), 0);
                    }

                    return FOTOCEDITOR_API_IMAGES + 'my-scale/resize/' + resizedWidth + '/' + resizedHeight + '?format=jpeg&quality=100&progressive=true&crop=true&gravity=north&url=/image-photo/' + m[4] + '260nw-' + m[5];

                } else {

                    return url;
                }

            };

            this.getProxyImageUrl = function ($url, $crop, $rezise) {
                return FOTOCEDITOR_IMAGES_PROXY + '?u=' + btoa($url) +
                    (typeof ($crop) != 'undefined' ? ('&c=' + $crop) : '') +
                    (typeof ($rezise) != 'undefined' ? ('&r=1') : '');
            };

            this.getProxyUploadCare = function ($url, $crop, $rezise) {
                var proxy = "https://befe7f4528284b5c01f9.ucr.io/" +
                    (typeof ($crop) != 'undefined' ? '-/crop/' + $crop + '/' : '') +
                    (typeof ($rezise) != 'undefined' ? ('-/resize/1024x/') : '') +
                    $url;
                return proxy;
            };

            function searchSilimarSizeFromPreviousManualSelecter($layout, forceSearchSize) {

                var layout_sizes = Object.keys($layout.sizes).map(function (s) {
                    return s.toUpperCase()
                });

                var selected;
                if (typeof (forceSearchSize) == 'undefined') {
                    selected = self.ui.sizeManualSelected.toUpperCase();
                } else {
                    selected = forceSearchSize.toUpperCase();
                }
                var index_of_layout = layout_sizes.indexOf(selected)

                if (index_of_layout !== -1) {
                    return Object.keys($layout.sizes)[index_of_layout];
                } else {

                    if (typeof (forceSearchSize) !== 'undefined') {
                        return false;
                    }

                    var posSearch = self.ui.availablesSizes.indexOf(selected);
                    var exist = false
                    var ret = false;

                    for (var i = 1; i < 10; i++) {

                        if (!exist) {
                            try {
                                if (self.ui.availablesSizes[posSearch - i]) {
                                    ret = searchSilimarSizeFromPreviousManualSelecter($layout, self.ui.availablesSizes[posSearch - i])
                                    if (ret !== false) {
                                        exist = true;
                                        break;
                                    }
                                }

                            } catch (e) {
                                console.warn(e);
                            }
                        }

                        if (!exist) {
                            try {
                                if (self.ui.availablesSizes[posSearch + i]) {
                                    ret = searchSilimarSizeFromPreviousManualSelecter($layout, self.ui.availablesSizes[posSearch + i])
                                    if (ret !== false) {
                                        exist = true;
                                        break;
                                    }
                                }
                            } catch (e) {
                                console.warn(e);
                            }
                        }
                    }

                    if (exist) {
                        return ret
                    }
                }
                return Object.keys($layout.sizes)[0];
            }
        }])
})();